module.exports = __webpack_public_path__ + "img/pd-img45.919ac37b.jpg";